<template>
  <Modal
    name="CHANGE_APPOINTMENT_HOST_MODAL"
    :title="$t('appointment.adminActions.changeHost.action')"
    actions
  >
    <template v-slot:body>
      <v-progress-linear
        class="mt-5 mb-7"
        v-show="isLoading"
        indeterminate
        rounded
      />

      <div v-show="!isLoading">
        <div class="mb-5" v-if="appointment.host">
          <h6 class="text-uppercase grey--text mb-0">
            {{ $t('appointment.adminActions.changeHost.currentHost') }}
          </h6>
          <span>
            {{ appointment.host.name }}
          </span>
        </div>

        <v-form ref="appointmentFormChangeHost" lazy-validation>
          <HostSelect
            v-model="host"
            :rules="[rules.required]"
            :dense="false"
            :notBlockedForAppointmentId="appointment.id"
          />
        </v-form>
      </div>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeAllModals"
        :disabled="isLoading || isChangingHost"
        elevation="0"
        class="mr-5"
        large
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        @click="validate"
        :loading="isLoading || isChangingHost"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('appointment.adminActions.changeHost.action') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { required } from '@/util/errorHandling'
import Modal from '@/components/app/Modal'
import HostSelect from '@/components/host/HostSelect'

export default {
  name: 'AppointmentChangeHost',
  components: {
    Modal,
    HostSelect
  },
  data() {
    return {
      isChangingHost: false,
      host: null,
      rules: {
        required
      },
    }
  },

  computed: {
    ...mapGetters(['appointment', 'isLoading']),
  },

  methods: {
    ...mapActions(['appointmentChangeHost']),
    ...mapMutations(['closeAllModals']),

    validate() {
      if (this.$refs.appointmentFormChangeHost.validate()) {
        this.isChangingHost = true

        const body = {
          appointment_id: this.appointment.id,
          host_id: this.host.id
        }

        this.appointmentChangeHost(body)
          .then(() => {
            if (this.$parent?.refreshMap) this.$parent?.refreshMap()
            if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
          })
          .then(() => this.closeAllModals())
          .finally(() => { this.isChangingHost = false })
      }
    },
  },
}
</script>
